import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Fade from '@mui/material/Fade';

export default function AccordionComponent(props) {
  const {title,children ,defaultExpanded, expanded, handleChange} = props;
  // const [expanded, setExpanded] = React.useState(false);

  // const handleChange = (panel) => (event, isExpanded) => {
  //   console.log(isExpanded)
  //   setExpanded(isExpanded ? panel : false);
  // };

  return (
    <div className='sba-accoridan-comp'> 
      <Accordion
        // defaultExpanded={defaultExpanded}
        expanded={expanded} 
        onChange={handleChange}
       
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{backgroundColor:"#f5f5f5 "}}
        >
          <h1>{title}</h1>
        </AccordionSummary>
        <AccordionDetails>
          {children}
        </AccordionDetails>
      </Accordion>
     
    </div>
  );
}